// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Default_wrapper__yTgN6","inner":"Default_inner__oH56j","toast":"Default_toast__gXmsn","icon":"Default_icon__d_W8w","message":"Default_message__L1sIo"};